import * as Yup from 'yup';


export const manageBackendUserValidation = (id) =>  Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Email is invalid").required("Email is required"),
    role: Yup.string().required("Role is required"),
    password: !id 
    ? Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required')
    : Yup.string().min(8, 'Password must be at least 8 characters').notRequired(),
    // password: Yup.string()
    //   .concat(!id ? Yup.string().required("Password is required") : null)
    //   .min(6, "Password must be at least 6 characters"),
    confirmPassword: Yup.string()
    .when("password", {
      is: (password) => (password && !id) || !!password,
      then: () => Yup.string().oneOf([Yup.ref("password")], "Passwords must match").required("Confirm Password is required"),
      otherwise: () => Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match")
    })
});

export const resetPasswordValidation = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
  confirmPassword: Yup.string().when("password", {
    is: (password) => password || !!password,
    then: () =>
      Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm Password is required"),
    otherwise: () =>
      Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match"),
  }),
});